import { useTranslation } from 'react-i18next'

export function FrankSetupGuide() {
  const { t } = useTranslation()
  const prefix = 'resources.assistants.integrations.frank_setup'

  return (
    <section
      aria-labelledby="frank-setup-title"
      className="rounded-lg border border-gray-200 p-6 dark:border-gray-700"
    >
      <h3
        id="frank-setup-title"
        className="text-base font-semibold text-gray-900 dark:text-gray-100"
      >
        {t(`${prefix}.title`)}
      </h3>
      <ol className="mt-4 space-y-6">
        {['application', 'channels', 'restaurant', 'configure'].map((step, index) => (
          <li key={step} className="flex gap-3">
            <span
              aria-hidden="true"
              className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-gray-100 text-sm font-semibold text-gray-700 dark:bg-gray-800 dark:text-gray-200"
            >
              {index + 1}
            </span>
            <div className="min-w-0 flex-1 space-y-2">
              <h4 className="text-sm font-semibold text-gray-900 dark:text-gray-100">
                {t(`${prefix}.${step}.title`)}
              </h4>
              <p className="text-sm text-gray-600 dark:text-gray-300">
                {t(`${prefix}.${step}.description`)}
              </p>
              {(step === 'application' || step === 'channels') && (
                <figure className="space-y-2">
                  <img
                    src={`/images/integrations/frank/${step === 'application' ? 'bonnie-application' : 'shift-channels'}.png`}
                    alt={t(`${prefix}.${step}.image_alt`)}
                    width={step === 'application' ? 790 : 672}
                    height={step === 'application' ? 76 : 346}
                    className="h-auto w-full rounded-lg border border-gray-200 dark:border-gray-700"
                  />
                  <figcaption className="text-xs text-gray-500 dark:text-gray-400">
                    {t(`${prefix}.${step}.caption`)}
                  </figcaption>
                </figure>
              )}
            </div>
          </li>
        ))}
      </ol>
      <p className="mt-5 border-t border-gray-200 pt-4 text-xs text-gray-500 dark:border-gray-700 dark:text-gray-400">
        {t(`${prefix}.verification`)}
      </p>
    </section>
  )
}
